import tmhRequest from '@/config/tmhRequest'

export default {
    searchBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/searchbookingorder',
            method: 'post',
            params: data,
        })
    },
    searchListBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/searchlistbookingorder',
            method: 'post',
            params: data,
        })
    },
    initTargetEmployee: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/inittargetemployee',
            method: 'post',
            params: data,
        })
    },
    initTargetRoom: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/inittargetroom',
            method: 'post',
            params: data,
        })
    },
    initTargetSource: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/inittargetsource',
            method: 'post',
            params: data,
        })
    },
    createBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/createbookingorder',
            method: 'post',
            data: data,
        })
    },
    editBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/editbookingorder',
            method: 'post',
            data: data,
        })
    },
    confirmBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/confirmbookingorder',
            method: 'post',
            params: data,
        })
    },
    multiConfirmBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/multiconfirmbookingorder',
            method: 'post',
            params: data,
        })
    },
    createServiceOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/createserviceorder',
            method: 'post',
            data: data,
        })
    },
    closeBookingOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/bookingorder/closebookingorder',
            method: 'post',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/ispa/order/bookingorder.js